import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { enableDebugTools } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
      const applicationRef = moduleRef.injector.get(ApplicationRef);
      const appComponent = applicationRef.components[0];
      enableDebugTools(appComponent);
    })
    .catch((err) => console.error(err));
}

// The disableServiceWorker flag only prevents new registrations (AppModule);
// a worker installed by an earlier visit stays in control until explicitly
// unregistered here. Takes full effect on the next reload.
function unregisterServiceWorkerIfDisabled(cfg: {
  disableServiceWorker?: unknown;
}): void {
  const disabled =
    cfg?.disableServiceWorker === 'true' || cfg?.disableServiceWorker === true;
  if (disabled && 'serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        registrations.forEach((registration) => registration.unregister()),
      )
      .catch(() => undefined);
  }
}

// Prefetch runtime config so module-eval-time decisions (service worker
// registration in AppModule) can read it before bootstrap. Failures are
// non-fatal — bootstrap proceeds and ConfigService re-fetches the cached file.
fetch('assets/config/config.json')
  .then((res) => res.json())
  .then((cfg) => {
    (window as unknown as Record<string, unknown>)['__APP_CONFIG__'] = cfg;
    unregisterServiceWorkerIfDisabled(cfg);
  })
  .catch(() => undefined)
  .finally(() => bootstrap());
